import { useMutation } from "@tanstack/react-query";
import { postSettlementReportsTriggerSettlement } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const useTriggerSettlementMutation = () =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postSettlementReportsTriggerSettlement(),
    ),
  });
